<template>
    <div class="select-ms">
        <label v-if="isLabel" for="">{{placeholder}}</label>
        <select name="" id="" @change="selectChange" :placeholder="placeholder" :value="modelValue" :disabled="disabled">
            <slot></slot>
        </select>
    </div>
</template>

<script>
export default{
    emits:['update:modelValue'],    
    methods:{
        selectChange(e){
            this.$emit('update:modelValue', e.target.value); 
        }
    },
    props:['modelValue','placeholder','isLabel','disabled'],
    data(){
        return{
        
        }
    }
}
</script>

<style>
.select-ms{
    height: 42px;
    position: relative;
}
.select-ms>select{
    font-family: Rubik,sans-serif;
    font-size: 14px;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    padding-left: 12px;
    padding-right: 68px;
    background-color: #EDF6FF;
    border: 1px solid #EDF6FF;
    border-radius: 10px;
    position: relative;
    appearance:none;
}
.select-ms label{
    position: absolute;
    top: -10px;
    left: 10px;
    z-index: 2;
    background: linear-gradient(0deg,rgba(237, 246, 255, 1) 0%, rgba(237, 246, 255, 1) 50%, rgba(255, 255, 255, 1) 50%, rgba(255, 255, 255, 1) 100%);

}
</style>